import React from 'react';
import {DatePicker, Form} from 'antd';
import {useField, Field} from 'formik';
import * as Utility from './utility';
import {useTranslation} from 'react-i18next';
import { Dayjs } from 'dayjs';

const {RangePicker} = DatePicker;

export const $RangePicker = ({
  errors,
  name,
  picker,
  label,
  hasFeedback,
  currentTimeFormat,
  disabledTime,
  disabledDate,
  value,
  disabled,
  size,
  onOk,
  placeholder,
  touched,
  noStyle,
  onChange,
  onOpenChange,
  minuteStep,
  formItem,
  style,
  order = true,
  allowClear,
  onCalendarChange
}: any) => {
  const [field, meta, helpers] = useField(name);
  const error = meta?.error;
  const isTouched = meta?.touched;
  const {t} = useTranslation();

  return (
    <Form.Item
      label={label}
      hasFeedback={hasFeedback}
      noStyle={typeof noStyle == 'undefined' ? false : true}
      help={isTouched && error && t(error as string)}
      validateStatus={Utility.validateStatus(error, isTouched)}
      {...formItem}
    >
      <Field
        as={RangePicker}
        {...field}
        style={style}
        picker={picker}
        minuteStep={minuteStep}
        size={size}
        name={name}
        onOk={onOk}
        allowClear={allowClear}
        format={currentTimeFormat}
        placeholder={placeholder}
        disabledTime={disabledTime}
        disabledDate={disabledDate}
        onOpenChange={onOpenChange}
        onCalendarChange={onCalendarChange}
        disabled={disabled}
        onChange={(times: [Dayjs, Dayjs]) => {
          onChange && onChange(times)
          helpers.setValue(times);
          helpers.setTouched(true);
        }}
        order={order}
      />
    </Form.Item>
  );
};